import type { ServiceOrganizationListApiResponse } from '@navio/nsdk';
import { URLKeys } from 'noddi-async';
import { type FilterOptionSource, usePagination } from 'noddi-ui-web';
import { useDebounceValue } from 'noddi-util';
import { toFilterOptionSource, useFilterOptionsGet } from '../useFilterOptionsGet';

/** Title, description and visible options of this filter, for the builder next to its options. */
export const SERVICE_ORGANIZATION_FILTER_TEXT = {
  title: 'Service organizations',
  description: 'Filter by specific service organizations',
  defaultVisibleOptions: 3
};

/** Service organizations as filter options, searchable. For `unit.multiSelect`. */
export const useServiceOrganizationOptions = ({
  brandIds,
  enabled = true
}: { brandIds?: number[]; enabled?: boolean } = {}): FilterOptionSource<number> => {
  const { pageIndex, pageSize, search, setSearch } = usePagination();
  const debouncedSearch = useDebounceValue({ value: search, delay: 300 });

  const query = useFilterOptionsGet({
    type: URLKeys.getPaginatedServiceOrganizations,
    input: {
      pageIndex,
      pageSize,
      search: debouncedSearch,
      brandIds
    },
    queryConfig: { enabled, select: toServiceOrganizationOptions }
  });

  return toFilterOptionSource(query, 'number', { search, onSearch: setSearch });
};

const toServiceOrganizationOptions = ({ results }: ServiceOrganizationListApiResponse) =>
  results.map((organization) => ({
    value: organization.id,
    label: organization.name,
    imageUrl: organization.logo?.url ?? organization.brand?.logo?.url
  }));
